// Tarefa 8.2 (FR-056): parser minimo de CSV para o modo "Previa" (tabela
// HTML) do toggle Previa/Codigo - sem nova dependencia (a spec nao pede uma
// biblioteca dedicada, diferente de FR-057/059/060). Cobre o essencial do
// RFC 4180: campos entre aspas (com virgula/quebra de linha dentro),
// aspas escapadas (""), e as duas convencoes de quebra de linha (\n, \r\n).
export function parseCsv(text) {
    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;

    for (let i = 0; i < text.length; i++) {
        const char = text[i];

        if (inQuotes) {
            if (char === '"') {
                if (text[i + 1] === '"') {
                    field += '"';
                    i++;
                } else {
                    inQuotes = false;
                }
            } else {
                field += char;
            }
            continue;
        }

        if (char === '"') {
            inQuotes = true;
        } else if (char === ',') {
            row.push(field);
            field = '';
        } else if (char === '\n' || char === '\r') {
            if (char === '\r' && text[i + 1] === '\n') i++;
            row.push(field);
            rows.push(row);
            row = [];
            field = '';
        } else {
            field += char;
        }
    }

    if (field.length > 0 || row.length > 0) {
        row.push(field);
        rows.push(row);
    }

    // Linha em branco no fim do arquivo (comum apos a ultima quebra de
    // linha) nao deve virar uma linha vazia na tabela.
    return rows.filter((r) => !(r.length === 1 && r[0] === ''));
}
